/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

const BaseClass = require('gemini/dashboard/layout/views/Widget');

import CreateExplorationLayout from 'components/startingPoints/create/CreateExplorationLayout';
import React from 'react';
import ReactDOM from 'react-dom';

const ExploreWidget = BaseClass.extend({
	init: function() {
		ExploreWidget.inherited('init', this, arguments);
		this.parentLayout && this.parentLayout.trackChildWidget(this);
		if(this.widgetModel && this.widgetModel.placeHolder) {
			this._renderPlaceHolder();
		}

		this._onShowInProgress = false;
	},

	destroy: function() {
		this.widgetChromeEventRouter = null;
		if(this.$el){
			//Unmount the react element to avoid zombie DOM
			ReactDOM.unmountComponentAtNode(this.$el.get(0));
		}
		// If no id no content so nothing to destroy
		this.id && ExploreWidget.inherited('destroy', this, arguments);
	},

	onKeyDown: (event) => {
		if (event.keyCode === 121) { // if F10 pressed dont open focus mode in Explore
			event.stopPropagation();
		}
	},

	_renderPlaceHolder: function() {
		const e = React.createElement(CreateExplorationLayout, {
			isComparison: this.parentLayout.model.isCompareEnabled,
			fill: true,
			services: this.services,
			activeDataSourceId: this.model.boardModel.layout.exploreVM.activeDataSourceId,
			handleShowVisTypesClick: this._showVisTypesDialog.bind(this),
			createVis: this.createVis.bind(this),
			dashboardApi: this.dashboardApi
		});
		ReactDOM.render(
			e,
			this.$el.get(0)
		);
	},

	_showVisTypesDialog: function() {
		this.model.boardModel.layout.exploreVM.setToolBarVisTypePicker(false, this);
		this.model.boardModel.layout.exploreVM.setShowModalVisTypePicker(true);
		this.parentLayout.view.widgetSelectionUpToDate = false;
	},

	createVis: function(widgetSpec) {
		this.parentLayout.replaceWithWidget(widgetSpec, this.model.id);
	},



	getSize: function(payload) {
		if (payload.deferred) {
			payload.deferred.resolve({});
		}
	}
});

export default ExploreWidget;



// WEBPACK FOOTER //
// ./src/js/layout/widget/ExploreWidget.js